package com.hyperether.goodjob.database

import kotlin.Long
import kotlin.String

public data class Site(
  public val id: Long,
  public val _id: String?,
  public val personName: String?,
  public val personAddress: String?,
  public val personPhone: String?,
  public val siteName: String?,
  public val parentId: String?,
  public val parentName: String?,
  public val personEmail: String?,
  public val workspaceId: String?,
)
